import { connect, FormikValues } from 'formik'
import { cloneDeep } from 'lodash'
import styled from 'styled-components'
import { string } from 'yup'

import Label from '@/components/Label'
import { VariableInputContainer } from '@/pages/SpaceAppBuilder/components/StyledComponents'
import VariableAutoComplete from '@/pages/SpaceAppBuilder/components/VariableInputDropdown/AutoCompleteVariableInput'
import { useWorkflowFeature } from '@/pages/SpaceAppBuilder/FeaturesPage/WorkflowFeatureContext'
import convertJSONtoSchema from '@/pages/SpaceAppBuilder/utilities/convertJSONToSchema'
import {
  FieldTypes,
  GenerateMicroappTokenStepData,
  StepData,
  Variable
} from '@/pages/SpaceAppBuilder/utilities/interfaces'

type GenerateMicroappTokenProps = {
  readOnly?: boolean
}

const StyledVariableInputContainer = styled(VariableInputContainer)`
  padding-top: 10px;
`

const getValidationSchema = () => {
  return {
    audience: string().required('Audience is required'),
    appId: string()
  }
}

const getInitialValues = (stepData: GenerateMicroappTokenStepData): StepData => {
  return {
    audience: stepData.audience ?? '',
    appId: stepData.appId
  }
}

const getNetworkRequestObject = (data: { triggerData: any; stepData: any }) => {
  const updatedValues: any = cloneDeep(data)
  const outputJson = { token: '' }

  updatedValues.output = convertJSONtoSchema(outputJson)
  return updatedValues
}

const GenerateMicroappTokenOperation = ({ formik, readOnly = false }: GenerateMicroappTokenProps & FormikValues) => {
  const { getVariablesForStep } = useWorkflowFeature()
  const variables = getVariablesForStep()

  const onSelectVariable = (variable: Variable, formikName: string) => {
    formik.setFieldValue(formikName, variable.name)
  }

  return (
    <>
      <Label className="mt-4" required>
        {'Audience'}
      </Label>
      <StyledVariableInputContainer>
        <VariableAutoComplete
          readOnly={readOnly}
          name={'stepData.audience'}
          variables={variables}
          validVariableTypes={[FieldTypes.STRING]}
          placeholder={'Select a variable to pass an audience.'}
          // @ts-expect-error
          onSelectOption={onSelectVariable}
          showValidationMessage={true}
          required
          formik={formik}
        />
      </StyledVariableInputContainer>
      <Label>{'App Id'}</Label>
      <StyledVariableInputContainer>
        <VariableAutoComplete
          readOnly={readOnly}
          name={'stepData.appId'}
          variables={variables}
          validVariableTypes={[FieldTypes.STRING]}
          placeholder={`Select a variable to pass an appId.`}
          // @ts-expect-error
          onSelectOption={onSelectVariable}
          showValidationMessage={true}
          formik={formik}
        />
      </StyledVariableInputContainer>
    </>
  )
}

export default connect(GenerateMicroappTokenOperation)

export { getInitialValues, getValidationSchema, getNetworkRequestObject }
